























import Vue from 'vue'
import request from '@/utils/request'
export default Vue.extend({
    data() {
        return {
            phone: '',
            password: '',
        }
    },
    methods: {
        submit() {
            if (!this.phone) {return this.$Message.warning('手机号码不能为空!')}
            if (!/^1[3456789]\d{9}$/.test(this.phone)) {return this.$Message.warning('请填写正确的手机号码!')}
            if (!this.password) {return this.$Message.warning('密码不能为空!')}
            const params = {
                phone: this.phone,
                password: this.password,
            }
            request.post(`/api/user/login`, params).then((result) => {
                if (result.code === 20000) {
                    this.$Message.success('登录成功!')
                    console.log(result)
                    this.$store.commit('login', result.msg)
                    sessionStorage.setItem('token', result.msg)
                    this.$router.push({ path: '/main' })
                } else {
                     this.$Message.success(result.msg)
                }
            }).catch((err) => {
                // console.log(err)
                this.$Message.error(err)
            })
            // this.$router.push({ path: '/layout' })
        },
        goRegister() {
            this.$router.push({ path: '/register' })
        },
    },
})
